<template>
  <div id="messageImage">
    <div class="messtitle"><div>純圖片訊息 </div> <span></span></div>
    <File :bg="'var(--color-pri)'" :folder="'message'" :style="{width: '660px', height: '450px', marginLeft: 0, marginTop: '13px'}"
    :defaultValue="defaultValue" @input="$emit('input', $event)"/>
  </div>
</template>

<script>
import File from '../../../components/input/file3.vue'
export default {
  props: ['defaultValue'],
  components: {
    File
  },
  data () {
    return {
    }
  },
  watch: {
  }
}
</script>
<style lang="scss">
#messageImage {
  rect {
    background-color: var(--color-pri);
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.messtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  display: flex;
  align-items: flex-end;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  height: 26px;
  gap: .5em;
  span {
    font-size: 12px;
    font-weight: 500;
    font-family: Roboto;
    line-height: 14px;
    color: #C4C4C4;
  }
}
#messageImage {
  width: 790px;
  height: 550px;
  border: 1px solid #CACACA;
  border-radius: 10px;
  padding: 25px 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
